import { render, staticRenderFns } from "./OurSolutions.vue?vue&type=template&id=b3494956&scoped=true"
import script from "./OurSolutions.vue?vue&type=script&lang=js"
export * from "./OurSolutions.vue?vue&type=script&lang=js"
import style0 from "./OurSolutions.vue?vue&type=style&index=0&id=b3494956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3494956",
  null
  
)

export default component.exports